import { reactive } from "vue";
import type { I18n } from "@/i18n";
import type { ILivePersonConfiguration } from "@/shared/live-person/types";
import type { Router } from "vue-router";

type GlobalVariablesType = {
  storeId?: string;
  catalogId?: string;
  userId?: string;
  isAuthenticated?: boolean;
  organizationId?: string;
  cultureName?: string;
  countryCode?: string;
  currencyCode?: string;
  i18n?: I18n;
  router?: Router;
  optimizelyHost?: string;
  optimizelyCdn?: string;
  optimizelyUrl?: string;
  hCaptchaSiteKey?: string;
  environment?: string;
  newProductsDayLimit?: number;
  leafletApiKey?: string;
  shippingOptionsFriendlyNames?: Record<string, string>;
  shippingTransitTimeText?: Record<string, string>;
  quoteExpiration?: Record<string, number>;
  sweAsMUCInEURCybersource?: boolean;
  convertCc478OrdersToNetTerms?: boolean;
  eusDocuSignEnabled?: boolean;
  inrCurrencyEnabled?: boolean;
  channelPartnerOrdersEnabled?: boolean;
  enable3DSPayerAuthentication?: string;
  erpImportRequestBodyAndResponseErrorInOrderDetails?: boolean;
  endUserStatements?: Record<
    string,
    Record<string, { pdf: string | null; docusign: string | null }> | { pdf: string | null; docusign: string | null }
  >;
  resellerEndUserStatements?: Record<
    string,
    Record<string, { pdf: string | null; docusign: string | null }> | { pdf: string | null; docusign: string | null }
  >;
  heavyWeightForm?: Record<string, Record<string, { pdf: string | null; docusign: string | null }>>;
  workableJobsApiURL?: string;
  algoliaConfig?: IAlgoliaConfig;
  appInsightsInstrumentationKey?: string;
  livePersonConfigOnCurrentLanguage?: ILivePersonConfiguration;
};

const globalVariables: GlobalVariablesType = {};

export const globals = globalVariables as Readonly<Required<GlobalVariablesType>>;
export const handledNotificationId = reactive({
  id: "",
});

export function setGlobals(variables: GlobalVariablesType) {
  Object.assign(globalVariables, variables);
}

export interface IAlgoliaConfig {
  applicationId?: string;
  searchApiKey: string;
  indexNamePrefix: string;
}
